import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-masterlinks',
  templateUrl: './masterlinks.component.html',
  styleUrls: ['./masterlinks.component.css']
})
export class MasterlinksComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

}
